import image1 from "../assets/t-image1.jpg";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpeg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I recently joined FitClub Gym, and I couldn't be happier with my decision. The gym is well-equipped with a wide range of modern machines and free weights, catering to all fitness levels and workout preferences. The facility is always clean and well-maintained, which adds to the overall positive atmosphere.",
    name: 'Anand Yadav',
    status : 'Student'
  },
  {
    image: image2,
    review: 'The staff at FitClub are friendly, knowledgeable, and always willing to help. They offer personalized training programs and group classes that are both challenging and fun. The trainers are attentive and genuinely invested in helping members achieve their fitness goals.',
    name: 'Shailendra Chaudhary',
    status: 'Student'
  },
  {
    image : image3,
    review:' One of the standout features for me is the community feel at FitClub. Members are supportive and encouraging, creating a motivating environment to push yourself. The gym also offers various amenities, such as a sauna and a juice bar, which enhance the overall experience.',
    name: 'Gaurav Tiwari',
    status: "Student"
  }
];
